import { render, staticRenderFns } from "./AccidentDialog.vue?vue&type=template&id=3394ba75&scoped=true"
import script from "./AccidentDialog.vue?vue&type=script&lang=js"
export * from "./AccidentDialog.vue?vue&type=script&lang=js"
import style0 from "./AccidentDialog.vue?vue&type=style&index=0&id=3394ba75&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3394ba75",
  null
  
)

export default component.exports